import React from 'react';
import EasyLoading from "../../../components/easy-loading";
import {EL_MODE_UPDATE} from "../../../components/easy-loading/constants";

const EasyLoadingUpdate = () =>
  <EasyLoading
    mode={EL_MODE_UPDATE}
  />;

export default EasyLoadingUpdate;


// WEBPACK FOOTER //
// ./src/scenes/easy-loading/easy-loading-update/index.jsx